import { cn, type PropsWithClassName } from "@/components/podkit/lib/cn";
import type { PropsWithTestId } from "@/components/podkit/lib/testid";
import type { FC, PropsWithChildren } from "react";

type PageProps = {} & PropsWithChildren & PropsWithClassName & PropsWithTestId;

export const Page: FC<PageProps> = ({ children, className, "data-testid": dataTestId }) => {
    return (
        <div data-testid={dataTestId} className={cn("flex max-h-full grow flex-col overflow-hidden", className)}>
            {children}
        </div>
    );
};
